<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div
		class="chat__contact flex items-center px-2 pt-4 pb-2"
		:class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}"
	>
		<div class="contact__avatar mr-1">
			<vs-avatar
				v-if="contact.admin || isDefaultChat(contact.key)"
				class="border-2 border-solid border-white"
				icon-pack="feather"
				icon="icon-users"
				color="primary"
				size="48px"
			/>
			<vs-avatar v-else class="border-2 border-solid border-white" :src="photoURL" size="48px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-5/6">
				<h5 class="font-semibold" :class="{'text-white': isActiveChatUser}" v-if="contact.admin">
					<div class="flex justify-between">
						{{ contact.name | capitalize }}
						<small style="font-size: 12px" class="font-normal text-dark"
							>{{ lastMessage ? getTime(lastMessage.time_stamp) : $t("Communication.NoMessages") }}
						</small>
					</div>
				</h5>
				<h5 v-else-if="isChat" class="font-semibold" :class="{'text-white': isActiveChatUser}">
					<div class="flex justify-between">
						{{ contact.name | capitalize }}
						<small style="font-size: 12px" class="font-normal text-dark"
							>{{ lastMessage ? getTime(lastMessage.time_stamp) : $t("Communication.NoMessages") }}
						</small>
					</div>
				</h5>
				<h5 v-else class="font-semibold" :class="{'text-white': isActiveChatUser}">
					{{ contact.name || getContactInfo().username | capitalize }}
				</h5>
				<span class="truncate text-sm" v-if="isChat">{{ lastMessage ? lastMessage.text : "" }}</span>
			</div>
			<div
				class="chat__contact__meta flex self-start flex-col items-end w-1/6 mr-2"
				v-if="isChat && thereAreUnseenMsg && !isActiveChatUser"
			>
				<vs-chip class="number" color="primary" v-if="!isActiveChatUser">{{ unseenMsg }}</vs-chip>
			</div>
			<div
				class="chat__contact__meta flex self-start flex-col items-end w-1/6 mr-2"
				v-if="isChat && contact.admin && unseenMsgGroup > 0"
			>
				<vs-chip class="number" color="primary">{{ unseenMsgGroup }}</vs-chip>
			</div>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

export default {
	props: {
		contact: {type: Object, required: true},
		isActiveChatUser: {type: Boolean},
		showLastMsg: {type: Boolean, default: false},
		userInfoId: {
			type: Number,
		},
	},
	data() {
		return {
			avatar: "",
			isChat: "",
		};
	},
	computed: {
		getTime() {
			return function (time) {
				const date_obj = new Date(+time);
				const newFormat = date_obj.getHours() >= 12 ? "p.m." : "a.m.";
				const minutes = date_obj.getMinutes() < 10 ? "0" + date_obj.getMinutes() : date_obj.getMinutes();
				const timeData = `${date_obj.getHours()}:${minutes} ${newFormat}`;
				const dateData = this.transformTimeStant(date_obj);
				const dateTime = this.transformTimeStant(new Date());
				if (dateData === dateTime) {
					return timeData;
				}
				return dateData;
			};
		},
		photoURL() {
			return this.avatar;
		},
		contacts() {
			return this.$store.state.chat.contacts;
		},
		messages() {
			return Object.hasOwn(this.contact, "messages") ? Object.values(this.contact.messages) : [];
		},
		lastMessage() {
			this.avatar = "";
			this.getResourcePhoto(this.isChat);
			const lastMessage = this.messages.sort((a, b) => b.time_stamp - a.time_stamp)[0];
			return lastMessage ? lastMessage : null;
		},
		unseenMsg() {
			return this.messages.filter((m) => !m.is_seen && m.sender !== +this.userInfoId).length;
		},
		thereAreUnseenMsg() {
			return this.messages.some(({is_seen, sender}) => !is_seen && sender !== +this.userInfoId);
		},
		unseenMsgGroup() {
			return Object.values(this.contact.messages).filter(
				({sender, is_seen}) => +sender !== +this.userInfoId && !is_seen[+this.userInfoId]
			).length;
		},
		isDefaultChat() {
			return (key) => key && key.split("_")[0] === "group";
		},
	},
	methods: {
		transformTimeStant(time) {
			const value = String(time);
			const date = value.slice(8, 10).trim();
			const month = value.slice(4, 7).trim();
			const year = value.slice(11, 15);
			return `${date} ${month} ${year}`;
		},
		contactImage(id) {
			return this.$store.getters["chat/contactImg"](id);
		},
		getContactInfo() {
			const memberId = this.contact.members.filter((member) => member !== +this.userInfoId);
			const contactInfo = this.contacts.find((contact) => contact.id === memberId[0]);
			return contactInfo;
		},
		getResourcePhoto(isChat) {
			const url = isChat ? (this.getContactInfo() ? this.getContactInfo().img_url : "") : this.contact.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
	},
	created() {
		const contactImg = this.contactImage(this.contact.id);
		this.isChat = Object.hasOwn(this.contact, "key");
		if (contactImg) {
			this.avatar = contactImg.img;
		} else {
			this.getResourcePhoto(this.isChat);
		}
	},
};
</script>
